import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useLocation } from 'react-router';

const NotAuthorized: React.FC = () => {
  const location = useLocation();

  const handleNavigation = () => {
    if (window.history.length > 2 && location.key !== 'default') {
      window.history.back();
    } else {
      window.location.replace('/');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 4,
      }}
    >
      <Typography
        variant="h1"
        color={'primary'}
        sx={{ fontSize: '12rem !important' }}
      >
        403
      </Typography>
      <Typography variant="subtitle1">
        Oops! You are not authrorized to view this page.
      </Typography>
      <Button variant="outlined" onClick={handleNavigation} size="large">
        Take Me Back to Safety
      </Button>
    </Box>
  );
};

export default NotAuthorized;
